import React, { useEffect, useState } from "react";
import "../css/Blogs.css";
import NavBar from "../components/NavBar";
import NavBarHome from "../components/NavBarHome";
import Pagination from "../components/Pagination";
import { useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

const Blogs = () => {
  const navigate = useNavigate();
  const [articles, setArticles] = useState([]);
  const [allSortedArticles, setAllSortedArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedTag, setSelectedTag] = useState("all");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");

  const domain = "c4x3xq-e0.myshopify.com";
  const itemsPerPage = 12;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const fetchAllArticles = async () => {
    setLoading(true);
    try {
      const articles = [];
      const blogQuery = `{
        blogs(first: 10) {
          edges {
            node {
              id
              handle
              title
            }
          }
        }
      }`;

      const blogRes = await fetch(
        `https://${domain}/api/2023-04/graphql.json`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token":
              process.env.REACT_APP_SHOPIFY_STOREFRONT_TOKEN,
          },
          body: JSON.stringify({ query: blogQuery }),
        }
      );
      const blogData = await blogRes.json();
      const blogs = blogData.data.blogs.edges;
      for (const blog of blogs) {
        let hasNextPage = true;
        let cursor = null;
        while (hasNextPage) {
          const articleQuery = `{
            blog(handle: "${blog.node.handle}") {
              articles(first: 50${cursor ? `, after: "${cursor}"` : ""}) {
                pageInfo {
                  hasNextPage
                  endCursor
                }
                edges {
                  node {
                    id
                    title
                    handle
                    publishedAt
                    excerpt
                    contentHtml
                    tags
                    image {
                      url
                      altText
                    }
                    authorV2 {
                      name
                    }
                  }
                }
              }
            }
          }`;

          const articleRes = await fetch(
            `https://${domain}/api/2023-04/graphql.json`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token":
                  process.env.REACT_APP_SHOPIFY_STOREFRONT_TOKEN,
              },
              body: JSON.stringify({ query: articleQuery }),
            }
          );

          const articleData = await articleRes.json();

          if (!articleData.data.blog) continue;

          const articlesEdges = articleData.data.blog.articles.edges;

          articles.push(
            ...articlesEdges.map((edge) => ({
              ...edge.node,
              tags: edge.node.tags || [], // pastikan tags diset
            }))
          );

          hasNextPage = articleData.data.blog.articles.pageInfo.hasNextPage;
          cursor = articleData.data.blog.articles.pageInfo.endCursor;
        }
      }

      const sortedArticles = articles.sort(
        (a, b) => new Date(b.publishedAt) - new Date(a.publishedAt)
      );

      setAllSortedArticles(sortedArticles);
    } catch (error) {
      console.error("Error fetching all articles:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllArticles();
  }, []);

  const filteredArticles = allSortedArticles.filter((article) => {
    const matchesSearch = article.title
      .toLowerCase()
      .includes(debouncedSearchQuery.toLowerCase()); // Gunakan debouncedSearchQuery

    const matchesTag =
      selectedTag === "all" || article.tags?.includes(selectedTag);

    return matchesSearch && matchesTag;
  });

  // Cek apakah ada artikel yang terfilter
  const noResults = filteredArticles.length === 0;

  const totalPages = Math.ceil(filteredArticles.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentArticles = filteredArticles.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 700); // debounce

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;

    const filteredArticles = allSortedArticles.filter((article) => {
      const matchesSearch = article.title
        .toLowerCase()
        .includes(debouncedSearchQuery.toLowerCase());

      const matchesTag =
        selectedTag === "all" || article.tags?.includes(selectedTag);

      return matchesSearch && matchesTag;
    });

    const pageArticles = filteredArticles.slice(
      startIndex,
      startIndex + itemsPerPage
    );

    setArticles(pageArticles);
  }, [currentPage, allSortedArticles, debouncedSearchQuery, selectedTag]);

  const email = localStorage.getItem("email");


  return (
    <>
     <Helmet>
        <title>Blog - Katie Glassman's Fiddle School</title>
        <meta
          name="description"
          content="Learn to play the fiddle with step-by-step video lessons, expert guidance from Katie Glassman, and a supportive online community."
        />

        {/* Open Graph */}
        <meta property="og:title" content="Blog - Katie Glassman's Fiddle School" />
        <meta
          property="og:site_name"
          content="Katie Glassman's Fiddle School"
        />
        <meta
          property="og:description"
          content="Learn to play the fiddle with step-by-step video lessons, expert guidance from Katie Glassman, and a supportive online community."
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:image"
          content="https://fiddleschool.com/logo192.png"
        />
        <meta property="og:url" content={window.location.href} />
      </Helmet>
      {email == "null" ? (
        <NavBar page={"blog"} />
      ) : (
        <NavBarHome page={"blog"} />
      )}
      <div className="blog-container">
        <h1 className="blog-title">Blog</h1>
        {!loading && (
          <div className="filter-container">
            <input
              type="text"
              placeholder="Search articles..."
              className="filter-search"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setCurrentPage(1);
              }}
            />

            <select
              className="filter-tags"
              value={selectedTag}
              onChange={(e) => {
                setSelectedTag(e.target.value);
                setCurrentPage(1);
              }}
            >
              <option value="all">All Tags</option>
              {[
                ...new Set(
                  allSortedArticles
                    .flatMap((a) => a.tags || [])
                    .filter((tag) => tag)
                ),
              ].map((tag) => (
                <option key={tag} value={tag}>
                  {tag}
                </option>
              ))}
            </select>
          </div>
        )}
        {loading ? (
          <div className="loading-blog">Loading...</div>
        ) : noResults ? (
          <div className="notFound-blog">No articles found</div>
        ) : (
          <div className="blog-list">
            {articles.map((article) => (
              <Link
                to={`/blog/${article.handle}`}
                className="blog-card"
                key={article.id}
              >
                {article.image?.url ? (
                  <img
                    src={article.image.url}
                    alt={article.image.altText || article.title}
                    className="blog-thumbnail"
                  />
                ) : null}

                <div className="blog-content">
                  <h2 className="blog-heading">{article.title}</h2>
                  <p className="blog-meta-blog">
                    {new Date(article.publishedAt).toLocaleDateString("en-US", {
                      day:"numeric",
                      month:"long",
                      year:"numeric",
                      timeZone: "UTC"
                    })}
                    <span className="dot-separator-blog">•</span>{" "}
                    {article.authorV2.name}
                  </p>
                  <p className="blog-excerpt">
                    {article.excerpt ||
                      article.contentHtml
                        .replace(/<[^>]+>/g, "")
                        .slice(0, 150) + "..."}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        )}
        {!loading && !noResults && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </>
  );
};

export default Blogs;
